
<template>
  <div 
  class="coupon-status" 
  v-if="getStatusText"
  >{{ getStatusText }}</div>
</template>
<script>
export default {
  name: 'CouponStatus',
  props: ['couponStatus'],
  computed: {
    getStatusText () {
      // 1已使用、2未使用、6已过期
      const obj = {
        1: this.$t('FoodC_C_Used_tgaq'),
        2: this.$t('FoodC_C_To_be_Qemy'),
        6: this.$t('FoodC_C_Expired_AEpg')
      }
      return obj[this.couponStatus] || ''
    }
  }
}
</script>
<style lang="scss" scoped>
.coupon-status {
  height: 42px;
  line-height: 42px;
  background: #31B77E;
  border-radius: 8px 0 8px 0px;
  font-family: "Aspira Medium";
  font-size: 22px;
  color: #ffffff;
  font-weight: 500;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  padding: 0 12px;
  z-index: 2;
}
</style>
